import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchLanguages } from 'slices/languageSlice';
import toast from 'react-hot-toast';
import { setError } from 'slices/languageTierSlice';
import { CustomSwitch } from 'components/common/Switch';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import { Controller, useForm } from 'react-hook-form';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import { updateLanguageTiers } from 'slices/languageTierSlice';
import { addLanguageTiers } from 'slices/languageTierSlice';
import { languageTierSelector } from 'slices/languageTierSlice';
import { fetchLanguagesTiers } from 'slices/languageTierSlice';
import { fetchTiersLanguages } from 'slices/languageSlice';
import { styled } from '@mui/material';
import { Dialog, DialogTitle, Modal } from '@mui/material';
const AddTiersForm = ({ item, handleClose, callback, show, statusPerm }) => {

  const { register, handleSubmit, watch, formState: { errors }, control, setValue, clearErrors } = useForm({
    defaultValues: {
      name: '',
      language_ids: [],
      status: 1,
    }
  });
  const [status, setStatus] = useState(1)
  const dispatch = useDispatch();
  const { error, loader } = useSelector(languageTierSelector);

  const clearAll = () => {
    setValue("name", '');
    setValue("language_ids", []);
    clearErrors("language_ids");
    clearErrors("name");
    setStatus(1)
    dispatch(setError({}))
    setLanguageState([])
  }
  useEffect(() => {
    setValue('name', item?.name || '');
    setValue("language_ids", item?.languages?.map(language => language.language_id) || [])
    setStatus((typeof (item?.status) == "number") ? item?.status : 1)

    return () => clearAll()
  }, [item]);

  useEffect(() => {
    return () => clearAll()
  }, [show])


  const submitCallback = (status, message) => {
    if (status) {
      callback()
      toast.success(message, {
        className: "successToast",
      })
      dispatch(fetchLanguagesTiers())
      handleClose()
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {
    dispatch(setError({}))
    data = {
      ...data,
      status,
    };
    if (item?.id) {
      dispatch(updateLanguageTiers(data, item?.id, submitCallback));
    } else
      dispatch(addLanguageTiers(data, submitCallback));

  }

  // #region Language dropdown
  const [languageState, setLanguageState] = useState({
    label: "",
    value: ""
  })

  useEffect(() => {
    setLanguageState(
      item?.languages?.map(val => ({
        label: val?.language?.name || "",
        value: val?.language?.id || ""
      }))
    );
  }, [item?.languages]);


  const filteredLanguagesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchTiersLanguages(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
    return {
      options: result?.data?.map(language => ({
        value: language.id,
        label: language.name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>

        <div className="row-primary">
          <h2>Tier Name *</h2>
          <div className="w-100">
            <Controller
              name="name"
              rules={{
                required: "Name is required"
              }}
              control={control}
              render={({ field }) => <input className="input-in type_inp" type="text" name='name' placeholder='Tier name' {...field} />}
            />
            {errors?.name?.message && <div style={{ marginBottom: 10 }}>
              <ErrorMessage text={errors?.name?.message} />
            </div>}
            {error?.errors?.name?.map((error) => (
              <div style={{ marginBottom: 10 }}>
                <ErrorMessage text={error} />
              </div>
            ))}
          </div>
        </div>

        <div className="row-primary">
          <h2>Select Languages *</h2>
          <Controller
            name="language_ids"
            required
            rules={{
              required: "Languages must be specified",
            }}
            control={control}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <div style={{ width: "100%" }}>
                  <AsyncPaginate
                    menuPlacement='auto'
                    isMulti
                    styles={{
                      ...selectCustomStyles,
                    }}
                    value={languageState || []}
                    loadOptions={filteredLanguagesLoadOptions}
                    isClearable
                    escapeClearsValue
                    onChange={(selected) => {
                      setLanguageState(selected)
                      field.onChange(selected.map((opt) => opt.value))
                    }}
                    additional={{
                      page: 1,
                    }}
                  />
                </div>
                {errors?.language_ids?.message && <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.language_ids?.message} />
                </div>}
              </div>
            }
          />
        </div>

        {statusPerm &&
          <div className="row-primary" style={{ alignItems: "center" }}>
            <h2 className='mt-0'>Status</h2>
            <CustomSwitch
              labelText="active"
              checked={status == 1 ? true : false}
              handleChange={(checked) => setStatus(checked ? 1 : 0)}
            />
          </div>
        }

        <div className="Form-footer">
          <button type="button" className="Cancle_button" onClick={handleClose} >Cancel</button>
          <SubmitButton
            btnText={item?.id ? "Update" : "Create"}
            loader={loader}
          />
        </div>
      </form>

    </div>
  )
}

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-container': {
    overflowY: "auto",
    margin: "auto",
    alignItems: "flex-start",
  },
  '& .MuiPaper-root': {
    maxHeight: "none",
    overflowY: "hidden",
    borderRadius: 20
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
    backgroundColor: "red"
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
    backgroundColor: "red"
  },
}));

const AddLanguageTiers = ({ item, onClose, callback, show, statusPerm }) => {

  return (
    <>

      <BootstrapDialog
        fullWidth={true}
        maxWidth={"md"}
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={show}
        sx={{
          '& .MuiDialog-container': {
            alignItems: "center",
          },
          '& .MuiPaper-root': {
            overflowY: "visible",

          },
        }}
      >
        <div className="">
          <div className="modal-content full_modal">
            <DialogTitle>
              <div className="modal-header header_modal align-items-center">
                <div></div>
                <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Language Tier</h5>
                <button type="button" className="btn-close"
                  // ref={refCloseScheduleButton}
                  aria-label="Close"
                  onClick={
                    () => {
                      onClose(item?.id, item?.status);
                    }
                  }

                ></button>
              </div>
            </DialogTitle>
            <div className="modal-body modal_form_body">
              <AddTiersForm item={item} handleClose={onClose} callback={callback} show={show} statusPerm={statusPerm} />
            </div>
          </div>
        </div>
      </BootstrapDialog>
    </>
  )
}

export default AddLanguageTiers
